import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=74d62fde&scoped=true&"
import script from "./Classify.vue?vue&type=script&lang=js&"
export * from "./Classify.vue?vue&type=script&lang=js&"
import style0 from "./Classify.vue?vue&type=style&index=0&id=74d62fde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d62fde",
  null
  
)

export default component.exports